<template>
  <div :class="{ 'add-select': add }">
    <el-select
      filterable
      :value="value"
      remote
      clearable
      size="small"
      @change="handleChange"
      :remote-method="requestData"
      :loading="loading"
      :placeholder="add ? '请选择或创建' : '请搜索并选择'"
      style="width: 100%"
      :popper-append-to-body="false"
      :class="{ long: !add }"
    >
      <el-option key="0" :value="0" label="请搜索选择" disabled></el-option>
      <el-option
        v-for="item in lists"
        :key="item.id"
        :label="`${item.name}（${item.sap_code}）`"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <el-button
      v-if="add"
      type="primary"
      plain
      class="ml-10"
      size="small"
      icon="el-icon-plus"
      @click="addCustomerFormVisible = true"
      >新建</el-button
    >
    <customer-former
      :category="category"
      :show.sync="addCustomerFormVisible"
      @createdCustomer="createdCustomer"
    ></customer-former>
  </div>
</template>

<script>
import { customerList } from '@/service/getData'
import CustomerFormer from '@/components/customer'

export default {
  components: {
    CustomerFormer,
  },
  props: {
    value: '',
    category: {
      type: Number,
      default: 0,
    },
    add: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
      addCustomerFormVisible: false,
    }
  },
  watch: {
    value(n) {
      if (n && this.lists.length == 0) {
        this.requestData('', n)
      }
    },
  },
  created() {
    if (this.value) {
      this.requestData('', this.value)
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e || null)
    },
    createdCustomer(res) {
      this.lists.push(res)
      this.$emit('input', res.id)
    },
    async requestData(query, defaultValue = 0) {
      if (query !== '' || defaultValue) {
        this.loading = true
        let data = {
          name: query,
          category: this.category || 0,
          customer_id: defaultValue,
          page: 0,
          size: 20,
          special_mark: -1,
        }
        let res = await customerList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>